import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/functions';
import config from 'config';

const firebaseConfig = config.firebase.config;

firebase.initializeApp(firebaseConfig);
firebase.database();
firebase.storage();
firebase.firestore();

export default firebase;
